<div
  class="create-annotation"
  (mousedown)="onMouseDown($event)"
  (mousemove)="onMouseMove($event)"
  (mouseup)="onMouseUp($event)"
  [class.block-mode]="blockMode"
>
  <app-view-annotation
    [sideMenuOpen]="sideMenuOpen"
    [asset]="asset"
    [scale]="scale"
    [offsetX]="offsetX"
    [offsetY]="offsetY"
    [offsetScale]="offsetScale"
    [shapes]="shapes"
    [noAnimate]="noAnimate"
  ></app-view-annotation>
</div>
